const LOCAL_HOSTNAMES = new Set(['localhost']);

export function isLocalEnvironment(): boolean {
    return LOCAL_HOSTNAMES.has(window.location.hostname);
}

export function isEmbeddedInIframe(): boolean {
    return window.self !== window.top;
}
